import Axios from 'axios';

import { AtlasMapUI, createMapInstances } from './atlas-mapUI';
import { Datastore } from './datastore';
import { INodesList, IGridCells, IMapData, IGridCell, IAtlasMaps, IObserver } from './interface';
import { AtlasGridItem } from './atlas-map-griditem';
import { AtlasNode } from './atlas-node';
import { AtlasPopup } from './atlas-popup';
import { Notification } from '../../../notification/notfication';
import { Confirm } from '../../../confirm/confirm';


class AtlasMap {
    private datastore = new Datastore();
    public Popup: AtlasPopup;
    private maps: IAtlasMaps;
    private slotSelectionList = [];

    public constructor(private ui: AtlasMapUI) {
        let selectedMapId: number = this.ui.getSelectedMapId();
        let mapId: number = Number(selectedMapId);

        this.ui.onSaveButtonClick(() => this.submit());
        this.ui.onSlotAfterChange((event: JQuery.TriggeredEvent) => this.slotAfterChange(event));
        this.ui.onSlotBeforeChange((event: JQuery.TriggeredEvent) => this.slotBeforeChange(event));
        this.ui.onAfterAtlasMapRender(() => this.atlasMapAfterRender());

        this.setSizeForGrid();

        this.ui.onWindowResize(() => this.setSizeForGrid());
        /**
         * Fetch all atlas maps
         */
        getAtlasMaps().then(data => {
            this.maps = data;
            const currentMap = this.maps.maps.filter(data => {
                if (Number(data.AtlasMap.id) === Number(this.ui.getSelectedMapId())) {
                    return data;
                }
            });

            const el = $('.atlas-map__grid');
            el.removeAttr('class');
            el.addClass('atlas-map__grid').addClass('atlas-map__grid--' + Number(currentMap[0].AtlasMap.height) + 'x' + Number(currentMap[0].AtlasMap.width));
        });

        /**
         * getAtlasMapCells
         * Fetch Map Cells from API and init GridItems
         */
        getAtlasMapCells(mapId).then(
            (
                cells: IGridCells
            ) => {
                this.initGridItems(
                    cells
                ).then(
                    () => {
                        this.datastore.UpdateCells(
                            cells
                        );
                        this.initPopup();
                    }
                );
            }
        );

        /**
         * Get server/nodes for the current server
         */
        getAtlasNodes().then((data) => {
            if (data.nodes) {
                data.nodes.map(item => {
                    this.datastore.RegisterObserver(new AtlasNode(item, this.datastore));
                });

                const Popup = new AtlasPopup(data, this.datastore);
                this.Popup = Popup;
                this.datastore.RegisterObserver(Popup);
                this.datastore.Popup = Popup;
            }

            this.datastore.UpdateData(data);
            AtlasNode.callGlobalRenderCallback();
        });

        /**
         * Get relationship between grid cell and node
         */
        getAtlasAssociations().then((data) => {
            this.datastore.UpdateAssociations(data);
            AtlasNode.callGlobalRenderCallback();
        });
    }

    /**
     * Set height & width for grid
     * This is needed for safari and mobile browsers
     */
    public setSizeForGrid() {
      this.ui.setMapImageSize({height: this.ui.getMapImageSize().height, width: this.ui.getMapImageSize().width});
    }

    /**
     * Handle saveButtonClick
     * Submit Data to API
     */
    public submit() {
        const data = this.mapToChangeRequest();
        postAtlasMapChanges(data).then((response) => {
            new Notification('success', 'Oki Doki :)', response.message);
        }).catch((error) => {
            new Notification('danger', 'Oops!', error.message);
        })
    }

    public mapToChangeRequest() {
        const bodyFormData = new FormData();
        const mapId: string = this.ui.getSelectedMapId().toString();
        const step = 'step';
        const serviceId = $('[data-service-id]')
            .first()
            .data('service-id');
        const data = [];

        // data.push({step: "nodeselection"});
        // data.push({mapId: mapId});

        bodyFormData.append('step', 'nodeselection');
        bodyFormData.append('mapId', mapId);

        $('.atlas-map__node')
            .not('.atlas-map__node--add')
            .each((index, el) => {
                if ($(el).find('select').val() && $(el).find('select').val() !== '') {
                    const locationId = $(el).find('select').data('location-id');
                    const nodeId = $(el).find('select').data('node-id');
                    const units = $(el).find('select').data('slot-value');

                    bodyFormData.append('nodeId[' + locationId + ']', nodeId);
                    bodyFormData.append('Slot[' + locationId + ']', $(el).find('select[data-type=\'units\']').val() as string);
                    bodyFormData.append('Location[' + locationId + ']', $(el).find('select[data-type=\'location\']').val() as string);
                }
            });

        return bodyFormData;
    }

    public initPopup() {
        this.datastore.RegisterObserver(this.datastore.Popup);
    }

    /**
     * InitGridItems
     * Create instances of AtlasGridItem and add to Observer
     * @param cells - array of map cell items
     */
    private initGridItems(cells: IGridCells) {
        return new Promise((resolve) => {
            cells.images.map((data: IGridCell, index: number) => {
                this.datastore.RegisterObserver(new AtlasGridItem(this.datastore, data, index));
            });
            resolve();
        })
    }

    /**
     *
     * @type {number}
     */
    readonly MIN_SLOTS: number = 10;

    /**
     *
     * @returns {number}
     */
    private getCurrentSlots(excludeElement : HTMLElement = null): number {
        let currentSlots: number = 0;

        $(AtlasMapUI.ATLAS_SLOT_SELECTOR).each((index: number, element: HTMLElement) => {
            if(!$(element).is(excludeElement)) {
                currentSlots += Number($(element).val());
            }
        });

        return currentSlots;
    }

    private atlasMapAfterRender(): void {
        let maxSlots : number = Number($(AtlasMapUI.ATLAS_CLUSTER_SLOT).data('value'));

        $(AtlasMapUI.ATLAS_SLOT_SELECTOR).each((index: number, element: HTMLElement) => {
            let maxAvailableSlotPerElement : number = maxSlots - this.getCurrentSlots(element);

            if(maxAvailableSlotPerElement >= this.MIN_SLOTS) {
                this.removeSlotsExceptSelected(element);
                this.addSlotsExceptSelected(element, maxAvailableSlotPerElement);
            }
        });
    }

    /**
     *
     * @param {JQuery.Event} event
     */
    private slotBeforeChange(event: JQuery.TriggeredEvent): void {

    }

    /**
     *
     * @param {HTMLElement} element
     */
    private removeSlotsExceptSelected(element : HTMLElement) {
        $(element).find('option').each((index: number, option: HTMLElement) => {
            if(!$(option).is(':selected')) {
                $(option).remove();
            }
        });
    }

    private addSlotsExceptSelected(element : HTMLElement, maxSlots : number) {
        let savedSlots : number = Number($(element).data('selected'));
        let nodeId = Number($(element).data('node-id'));

        for(let slot = this.MIN_SLOTS; slot <= maxSlots; slot += 2) {
            let optionExists : boolean = false;

            if(!$(element).find("option[value='" + slot + "']").length) {
                let optionField = new Option(slot.toString(), slot.toString());

                if(this.slotSelectionList[nodeId] !== undefined) {
                    if(this.slotSelectionList[nodeId] === slot) {
                        optionField.setAttribute('selected', 'selected');
                    }
                }
                else if(savedSlots === slot) {
                    optionField.setAttribute('selected', 'selected');
                }

                $(element).append(optionField);
            }
        }
    }

    private slotAfterChange(event : JQuery.TriggeredEvent): void {
        let nodeId = $(event.target).data('node-id');
        let maxSlots : number = Number($(AtlasMapUI.ATLAS_CLUSTER_SLOT).data('value'));
        this.slotSelectionList[nodeId] = Number($(event.target).val());
        $(AtlasMapUI.ATLAS_SLOT_SELECTOR).each((index: number, element: HTMLElement) => {
            let maxAvailableSlotPerElement : number = maxSlots - this.getCurrentSlots(element);

            this.removeSlotsExceptSelected(element);
            this.addSlotsExceptSelected(element, maxAvailableSlotPerElement);

            $(AtlasMapUI.ATLAS_SLOT_DISPLAY).text(maxSlots - this.getCurrentSlots());
        });
    }
}

export function initAtlasMap() {
    return createMapInstances().map((ui: AtlasMapUI) => {
        return new AtlasMap(ui);
    });
}

export function getAtlasNodes(): Promise<INodesList> {
    const url: string = window.atlasGetNodesForClusterUrl;

    return new Promise((resolve, reject) => {
        Axios.get(url, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => {
            resolve(response.data);
        });
    })
}

export function getAtlasMapCells(mapId: number): Promise<IGridCells> {
    const url: string = window.atlasGetMapCellsUrl + '/' + mapId;

    return new Promise((resolve, reject) => {
        Axios.get(url, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => resolve(response.data));
    });
}

export function getAtlasAssociations(): Promise<IMapData> {
    const url: string = window.atlasGetNodesToCellUrl;

    return new Promise((resolve) => {
        Axios.get(url, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => resolve(response.data));
    });
}

export function getAtlasMaps(): Promise<IAtlasMaps> {
    const url: string = window.atlasGetMapsUrl;

    return new Promise((resolve) => {
        Axios.get(url, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => {
            resolve(response.data)
        });
    });
}

export function postAtlasMapChanges(data: any): Promise<{ message: string }> {
    const url: string = window.atlasPostSubmitMapUrl;
    return new Promise((resolve, reject) => {
        Axios.post(url, data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then((response) => {
                if (response.data.result) {
                    resolve(response.data);
                } else {
                    reject(response.data);
                }
            })
            .catch((error) => reject(error.data));
    })
}

export function addNodeServer(): Promise<any> {
    return new Promise((resolve, reject) => {
        Axios.get(window.addExpansionServerUrl)
            .then(response => resolve(response.data))
            .catch(error => reject(error.data));
    });
}

$(document).on('ready', () => {
    /**
     * Show error popup
     */
    if (window.atlasAlertMessage !== undefined) {
        new Notification('danger', 'Oops!', window.atlasAlertMessage, true);
    }

    $('[data-add-node]').on('click', (e) => {
        e.currentTarget.classList.add('loading');

        new Confirm('Your gameserver will be stopped, when adding a expansion server. Do you want to do that?', () => {
            $(e.currentTarget).attr('disabled', 'disabled');
            Axios.get(window.addExpansionServerUrl).then(response => {
                if (response.data.result) {
                    new Notification('success', 'Done', response.data.message);
                    e.currentTarget.classList.remove('loading');
                    $(e.currentTarget).removeAttr('disabled');
                    window.setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                } else {
                    if (response && response.data && response.data.message) {
                        new Notification('danger', 'Ooops!', response.data.message);
                    } else {
                        new Notification('danger', 'Ooops!', 'Something went wrong. Please try again later.');
                    }

                    $(e.currentTarget).removeAttr('disabled');
                    e.currentTarget.classList.remove('loading');
                }

                if (response.data.redirectUrl) {
                    window.setTimeout(() => {
                        document.location.href = response.data.redirectUrl;
                    }, 3000);

                    return;
                }
            });
        }, () => {
            $(e.currentTarget).removeAttr('disabled');
            e.currentTarget.classList.remove('loading');
        })
    });

    $('.cluster [data-backup-all]').on('click', (e: JQuery.TriggeredEvent) => {
        new Confirm('Do you really want to create a backup of each cluster node? This process can take several minutes.', () => {
            $(e.target).addClass('loading').attr('disabled', 'disabled');

            new Notification('info', 'Backup all', 'This process can take several minutes, please be a little patient!');

            Axios.get(window.clusterBackupUrl, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
                .then(response => {
                    $(e.target).removeClass('loading').removeAttr('disabled');
                    new Notification('success', 'Done', response.data.message);
                })
                .catch((error: string) => {
                    $(e.target).removeClass('loading').removeAttr('disabled');
                    new Notification('danger', 'Ooops!', error);
                });
        }, () => {
        });
    });
});
